import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import TechTaskProgressBar from './TechTaskProgressBar';
import '@/styles/ipe/workbench/components/TechTaskProgressBar.css';

function formatTaskCreatedAt(createdAt) {
  if (!createdAt) return '—';
  if (typeof createdAt === 'string' && createdAt.includes('T')) {
    return format(new Date(createdAt), 'yyyy-MM-dd HH:mm:ss');
  }
  return createdAt;
}

/**
 * 与图片裁剪列表一致的信息列：时间/操作人 + 科技感进度条
 * @param {{ task: object, getCompletionDisplay: (task: object) => object, topExtra?: React.ReactNode }} props
 */
export default function TechTaskInfoCell({
  task,
  getCompletionDisplay,
  topExtra = null,
  operatorName = '',
  countUnit = '',
}) {
  const { t } = useTranslation('workbench');
  const completion = getCompletionDisplay(task);
  const percentDisplay = Math.round(completion.percent ?? 0);
  const resolvedOperator = task.operator
    || task.operatorName
    || task.createdBy
    || task.creator
    || String(operatorName || '').trim()
    || '';
  const operatorText = String(resolvedOperator || '').trim()
    ? resolvedOperator
    : t('studioChrome.system');

  return (
    <div className="crop-task-info-cell">
      {topExtra}
      <div className="crop-task-info-meta crop-task-info-meta--stacked">
        <span className="crop-task-info-meta__item">
          <span className="crop-task-info-label">{t('studioChrome.timeLabel')}</span>
          <span className="crop-task-info-value crop-task-info-value--mono">
            {formatTaskCreatedAt(task.createdAt)}
          </span>
        </span>
        <span className="crop-task-info-meta__item">
          <span className="crop-task-info-label">{t('studioChrome.operatorLabel')}</span>
          <span className="crop-task-info-value">{operatorText}</span>
        </span>
      </div>

      {completion.variant === 'success' ? (
        <div className="crop-task-complete-summary">
          {completion.total > 0 ? (
            <span className="crop-task-complete-summary__detail">
              <span className="crop-task-complete-summary__detail--done">{t('studioChrome.allDone')}</span>
              <span className="crop-task-complete-summary__detail--count">
                {` · ${t('studioChrome.countLine', {
                  count: Number(completion.total).toLocaleString('zh-CN'),
                  unit: countUnit || t('studioChrome.unitSheet'),
                })}`}
              </span>
            </span>
          ) : (
            <span className="crop-task-complete-summary__detail crop-task-complete-summary__detail--done">
              {t('studioChrome.allDone')}
            </span>
          )}
        </div>
      ) : completion.showBar ? (
        <div className="crop-task-progress-block">
          <div className="crop-task-status-header">
            <span
              className={`crop-task-status-dot crop-task-status-dot--${completion.variant}`}
              aria-hidden
            />
            <span className={`crop-task-status-text crop-task-status-text--${completion.variant}`}>
              {completion.statusLabel}
            </span>
          </div>
          <TechTaskProgressBar percent={completion.percent} variant={completion.variant} />
          <div className="crop-task-progress-foot">
            <span className="crop-task-progress-foot__left">{completion.detailLeft}</span>
            <span className={`crop-task-progress-foot__pct crop-task-progress-foot__pct--${completion.variant}`}>
              {percentDisplay}%
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
}
